// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AccountType } from '@shared/utils/cache/Accounts/Account.types';
import { MathUtils } from '@shared/utils/MathUtils';
import { DataCache } from '../DataCache';
export class AccountOperationInfo {
    UpdateByMessage(accOperMess) {
        if (accOperMess == null) {
            return;
        }
        this.RequestId = accOperMess.RequestId;
        this.AccountId = accOperMess.AccountId;
        if (accOperMess.CounterId != null) {
            this.CounterId = accOperMess.CounterId;
        }
        else {
            this.CounterId = '';
        }
        this.LastUpdateTime = accOperMess.LastUpdateTime;
        this.OperationType = accOperMess.OperationType;
        this.Mode = accOperMess.Mode;
        this.Amount = accOperMess.Amount;
        if (accOperMess.CrossPrice !== null) {
            this.CrossPrice = accOperMess.CrossPrice;
        }
        this.Comment = accOperMess.Comment;
        this.AssetId = accOperMess.AssetId;
        const account = DataCache.GetAccountByNumber(this.CounterId);
        const asset = account == null || account.AccountType === AccountType.MultiAsset || account.assetBalanceDefault == null
            ? DataCache.GetAssetById(this.AssetId)
            : account.assetBalanceDefault.Asset;
        if (this.CrossPrice !== 0) {
            this.Counter_Amount = Math.abs(this.Amount * this.CrossPrice);
        }
        else {
            this.Counter_Amount = Math.abs(this.Amount);
        }
        if (asset != null) {
            // TODO
            this.Counter_Amount = MathUtils.Round(this.Counter_Amount, asset.Point);
        }
    }
}
AccountOperationInfo.TYPE_WITHDRAW = 3;
AccountOperationInfo.TYPE_BLOCKING = 8;
AccountOperationInfo.TYPE_TRANSFER = 17;
AccountOperationInfo.MODE_PENDING = 0;
AccountOperationInfo.MODE_APPROVE = 1;
AccountOperationInfo.MODE_CANCEL = 2;
